import { CommonModule } from '@angular/common';
import { Component, HostListener, computed } from '@angular/core';
import { IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import {
  addOutline,
  copyOutline,
  constructOutline,
  createOutline,
  eyeOffOutline,
  eyeOutline,
  layersOutline,
  lockClosedOutline,
  lockOpenOutline,
  openOutline,
  saveOutline,
  sparklesOutline,
  trashOutline
} from 'ionicons/icons';
import { AppContextMenuService } from '../../services/app-context-menu.service';

@Component({
  selector: 'app-context-menu',
  standalone: true,
  imports: [CommonModule, IonIcon],
  templateUrl: './app-context-menu.component.html',
  styleUrls: ['./app-context-menu.component.scss']
})
export class AppContextMenuComponent {
  readonly menuState = this.contextMenuService.state;
  readonly menuStyles = computed(() => {
    const state = this.menuState();

    if (!state.open) {
      return {};
    }

    const viewportWidth = typeof window !== 'undefined' ? window.innerWidth : state.x + 264;
    const viewportHeight = typeof window !== 'undefined' ? window.innerHeight : state.y + 280;

    return {
      left: `${Math.max(12, Math.min(state.x, viewportWidth - 264))}px`,
      top: `${Math.max(12, Math.min(state.y, viewportHeight - 280))}px`
    };
  });

  constructor(private readonly contextMenuService: AppContextMenuService) {
    addIcons({
      addOutline,
      copyOutline,
      constructOutline,
      createOutline,
      eyeOffOutline,
      eyeOutline,
      layersOutline,
      lockClosedOutline,
      lockOpenOutline,
      openOutline,
      saveOutline,
      sparklesOutline,
      trashOutline
    });
  }

  invoke(itemId: string): void {
    this.contextMenuService.invoke(itemId);
  }

  close(): void {
    this.contextMenuService.close();
  }

  @HostListener('document:click')
  handleDocumentClick(): void {
    this.close();
  }

  @HostListener('document:keydown.escape')
  handleEscape(): void {
    this.close();
  }

  @HostListener('window:blur')
  handleWindowBlur(): void {
    this.close();
  }
}
